export default "__VITE_ASSET__DzIRk0Au__"